import React from 'react';
import { Dataset } from "../model/index.js";
import { BinnedSampleCard } from './BinnedSampleCard.js';
import { HistogramPlotCard } from './HistogramPlotCard.js';
import { SampleDefTable } from "./SampleDefTable.js";
import { SummaryCard } from "./SummaryCard.js";
import { SummaryCardBinned } from './SummaryCardBinned.js';
export function HistogramPane() {
    const [data, setData] = React.useState([]);
    const [bins, setBins] = React.useState([]);
    const [decimals, setDecimals] = React.useState(2);
    const dataset = React.useRef(new Dataset(setData, [
        9.1,
        2.3,
        4.5,
        8.1,
        12.8,
        10.5,
        9.4,
    ]));
    React.useMemo(() => setData([...dataset.current.data]), [dataset]);
    return (React.createElement("div", { className: 'histogram-pane' },
        React.createElement("div", { className: "card", style: { display: "flex", backgroundColor: "grey", color: "white", margin: 0, borderRadius: 0, alignItems: "center" } },
            React.createElement("p", null, "HISTOGRAM"),
            React.createElement("div", { style: { width: "30px" } }),
            React.createElement("div", { id: "formSettings" },
                React.createElement("label", { htmlFor: "decimalsInput" }, "Desetinn\u00E1 m\u00EDsta"),
                React.createElement("input", { type: "number", id: "decimalsInput", defaultValue: 2, min: 0, onChange: e => setDecimals(Math.max(Number(e.target.value), 0)) }))),
        React.createElement("div", { id: "container1", style: { display: "flex", gap: 0 } },
            React.createElement("div", { style: { width: "150px", flexBasis: "auto", flexGrow: "auto" }, className: "card" },
                React.createElement("p", { className: "cardTitle" }, "Statistick\u00FD soubor"),
                React.createElement(SampleDefTable, { data: data, dataset: dataset.current })),
            React.createElement("div", { style: { flexBasis: "auto", flexGrow: "auto" } },
                React.createElement(SummaryCard, { data: data, decimals: decimals })),
            React.createElement("div", { style: { flexBasis: 4, flexGrow: 4 } },
                React.createElement(BinnedSampleCard, { data: data, bins: bins, setBins: (value) => setBins(value), decimals: decimals })),
            React.createElement("div", { style: { flexBasis: 4, flexGrow: 4 } },
                React.createElement(HistogramPlotCard, { bins: bins }),
                React.createElement(SummaryCardBinned, { bins: bins, decimals: decimals })))));
}
//# sourceMappingURL=HistogramPane.js.map